// extracted by mini-css-extract-plugin
export default {"CopyToClipBoardLabelContainer":"CopyToClipboard_CopyToClipBoardLabelContainer__roYW4"};